import React from 'react';

import _data from '../../data';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutUs: {}
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      aboutUs: _data.aboutUs
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="overflow-hidden">
          <section id="about" className="about-us ptb-100 background-shape-img">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-md-7">
                  <div className="about-content-left section-heading">
                    <h2>
                      Tu tienda personalizada<br />
                      <span>en Frisbee App</span>
                    </h2>

                    <div className="single-feature mb-4 mt-5">
                      <div className="icon-box-wrap d-flex align-items-center mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-1.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <p className="mb-0">
                          Tu marca tiene su personalidad, voz e identidad que quieres seguir creciendo.
                          En Frisbee vas a tener un perfil especial para tu marca, elige tu foto de perfil, 
                          foto de portada y muéstrale a tus clientes que hace a tu producto especial.
                        </p>
                      </div>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-2.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <p className="mb-0">
                          Participa en nuestros Flash Sales exclusivos. Elige un descuento semanal, y aplícalo a los productos y cantidades que elijas.
                          Los clientes tienen una hora para comprar locamente todas las promociones!
                        </p>
                      </div>
                      <p></p>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-3.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <p className="mb-0">
                          Dale un espacio a tu marca en la palma de la mano de todos quienes tengan un smartphone.
                          Nuestra app Frisbee está optimizada para una experiencia increíble en iOS y Android.
                        </p>
                      </div>
                      <p></p>
                    </div>
                    <div className="single-feature mb-4">
                      <div className="icon-box-wrap mb-2">
                        <div className="mr-3 icon-box">
                          <img
                            src="img/image-icon-4.png"
                            alt="icon"
                            className="img-fluid"
                          />
                        </div>
                        <p className="mb-0">
                          Frsibee es Shoppable Marketing.
                          Sube posts y stories, etiquetando tus productos y tus clientes van a poder 
                          ir al checkout, pagar y recibir su producto rápida y efectivamente.
                        </p>
                      </div>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="about-content-right d-flex justify-content-center justify-content-lg-end justify-content-md-end">
                    <img
                      src="img/tienda-personalizada.png"
                      alt="Tienda Personalizada"
                      className="img-fluid"
                    />
                    
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default About;
